module.exports = __webpack_public_path__ + "static/img/trend.6db6a80c.png";